export const GROUP_COLLAPSE_TOKEN = {
  contentPadding: '0',
  headerPadding: '0 0 12px',
};

export const CONTROL_COLLAPSE_TOKEN = {
  contentPadding: '8px 16px',
  headerPadding: '8px 16px',
};
